import { Check } from "lucide-react";
import type { BenefitItem } from "../types";

interface BenefitCardProps {
  benefit: BenefitItem;
}

function renderBenefitText(text: string, highlights: string[] = []) {
  if (!highlights.length) {
    return text;
  }

  // Split text around highlight phrases while preserving order
  const parts: { value: string; bold: boolean }[] = [];
  let remaining = text;

  for (const highlight of highlights) {
    const index = remaining.indexOf(highlight);
    if (index === -1) continue;
    if (index > 0) {
      parts.push({ value: remaining.slice(0, index), bold: false });
    }
    parts.push({ value: highlight, bold: true });
    remaining = remaining.slice(index + highlight.length);
  }

  if (remaining) {
    parts.push({ value: remaining, bold: false });
  }

  if (!parts.length) {
    return text;
  }

  return parts.map((part, i) =>
    part.bold ? (
      <strong key={i} className="font-semibold text-slate-900">
        {part.value}
      </strong>
    ) : (
      <span key={i}>{part.value}</span>
    )
  );
}

export function BenefitCard({ benefit }: BenefitCardProps) {
  return (
    <li className="flex items-start gap-3">
      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-100">
        <Check className="h-3.5 w-3.5 text-amber-600" strokeWidth={3} />
      </span>
      <p className="text-sm leading-relaxed text-slate-700 sm:text-[15px]">
        {renderBenefitText(benefit.text, benefit.highlights)}
      </p>
    </li>
  );
}
